import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { inject } from '@app/providers/QAU.ContextProvider';
import { changeMeasurement } from '@app/actions/customizeActions';
import { checkOptionFromLocalStorage, setOptionToLocaleStorage } from '@app/utils/utils';
import { getLocale } from '@app/utils/measurement';
import useIntlMessage from '@app/hooks/use-intl-message';
import LabeledToggle from '@components/labeled-toggle/LabeledToggle';
import './ChangeMeasurementTool.scss';
import PropTypes from 'prop-types';

const localStorageKey = 'avery.fau.measurement';

const ChangeMeasurementTool = ({
  changeMeasurement,
  flowConfig: {
    locale: { measurementSystem },
  },
  disabled,
}) => {
  const initialMeasurement = checkOptionFromLocalStorage(localStorageKey, getLocale(measurementSystem));
  const [localeMeasurement, setLocaleMeasurement] = useState(initialMeasurement);
  const [sizeUnitsSelectAriaLabel] = useIntlMessage('qau-artwork-size-units-aria-label');

  const onMeasurementChange = ({ target: { value } }) => setLocaleMeasurement(value);
  useEffect(() => {
    changeMeasurement(localeMeasurement);
    setOptionToLocaleStorage(localStorageKey, localeMeasurement);
  }, [localeMeasurement, changeMeasurement]);

  return (
    <div id="qau-change-measurement-tool" aria-label={sizeUnitsSelectAriaLabel}>
      <LabeledToggle
        ariaLabelLocaleKey="qau-artwork-size-units-aria-label"
        options={['inches', 'millimeters']}
        onChange={onMeasurementChange}
        checked={localeMeasurement}
        disabled={disabled}
        small
      />
    </div>
  );
};

const mapStateToProps = (state, { flow: { flowConfig } }) => ({ flowConfig });

ChangeMeasurementTool.propTypes = {
  changeMeasurement: PropTypes.func.isRequired,
  flowConfig: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
};

export default inject('flow')(connect(mapStateToProps, { changeMeasurement })(ChangeMeasurementTool));
